import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone, Building2 } from 'lucide-react';
import { CONTACT_INFO, BRAND_INFO, COUNTRY_OF_ORIGIN } from '../../data/mock';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-cream-50 border-t border-cream-200 text-ink-800">
      <div className="container-wide pt-16 pb-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 pb-10 border-b border-cream-200">
          {/* Quick links */}
          <div className="lg:col-span-3">
            <h4 className="font-display text-2xl text-ink-900 mb-5">Quick links</h4>
            <ul className="space-y-3 text-[15px]">
              {[
                { p: '/panels',     l: 'Shop labs' },
                { p: '/platform',   l: 'Our platform' },
                { p: '/about',      l: 'About us' },
                { p: '/faq',        l: 'FAQ' },
              ].map((it) => (
                <li key={it.p}>
                  <Link to={it.p} className="text-ink-700 hover:text-brick-500 transition-colors">
                    {it.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <h4 className="font-display text-2xl text-ink-900 mb-5">Contact</h4>
            <ul className="space-y-3 text-[15px]">
              <li className="flex items-start gap-2.5">
                <Mail className="w-4 h-4 mt-1 text-brick-500" />
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-brick-500">
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <Phone className="w-4 h-4 mt-1 text-brick-500" />
                <a href={`tel:${CONTACT_INFO.phone.replace(/[^0-9]/g, '')}`} className="hover:text-brick-500">
                  {CONTACT_INFO.phone}
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <MapPin className="w-4 h-4 mt-1 text-brick-500" />
                <span>
                  {CONTACT_INFO.address.street}<br />
                  {CONTACT_INFO.address.city}, {CONTACT_INFO.address.state} {CONTACT_INFO.address.zip}<br />
                  {CONTACT_INFO.address.country}
                </span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="lg:col-span-3">
            <h4 className="font-display text-2xl text-ink-900 mb-5">Legal</h4>
            <ul className="space-y-3 text-[15px]">
              {[
                { p: '/terms',              l: 'Terms and conditions' },
                { p: '/privacy',            l: 'Privacy policy' },
                { p: '/refund',             l: 'Refund policy' },
                { p: '/subscription',       l: 'Subscription disclosure' },
                { p: '/medical-disclaimer', l: 'Medical disclaimer' },
              ].map((it) => (
                <li key={it.p}>
                  <Link to={it.p} className="text-ink-700 hover:text-brick-500 transition-colors">
                    {it.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Trust block */}
          <div className="lg:col-span-2 text-[12px] text-ink-600 leading-relaxed">
            <div className="flex items-start gap-2.5 mb-3">
              <Building2 className="w-4 h-4 mt-0.5 text-brick-500" />
              <div>
                <div className="text-ink-900 font-medium">{CONTACT_INFO.corporateName}</div>
                <div>Country of origin: {COUNTRY_OF_ORIGIN}</div>
                <div>Billing descriptor: {BRAND_INFO.billingDescriptor}</div>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-1.5 mt-3">
              {['Visa', 'MC', 'Amex', 'Disc'].map((c) => (
                <span
                  key={c}
                  className="inline-block px-2 py-1 rounded-md bg-white border border-cream-200 text-ink-900 text-[10px] font-bold tracking-wider"
                >
                  {c}
                </span>
              ))}
            </div>
            <div className="mt-3">All prices in USD · SSL Secured 256-bit encryption</div>
          </div>
        </div>

        <div className="pt-6 flex flex-col md:flex-row gap-3 items-center justify-between text-[12px] text-ink-500">
          <div>© {year} {CONTACT_INFO.corporateName}. All rights reserved.</div>
          <div className="text-ink-500/90">
            {BRAND_INFO.domain} · Health information platform — not medical advice.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
